interface IconGeneralProps {
  className?: string;
  size?: string | number;
}

const IconGeneral = (props: IconGeneralProps) => {
  const Size = props.size ?? '24';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Size}
      height={Size}
      viewBox="0 0 24 24"
      className={props.className}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0m6-2h6m-6 4h6"
      />
    </svg>
  );
};

export default IconGeneral;
